import { Component, Input } from '@angular/core';
import { Client, ProductGroup } from '@app/core/models/client';
import { BannerPreviewComponent } from '../banner-preview/banner-preview.component';
import { FormsModule } from '@angular/forms';
import { SafeHtmlPipePipe } from '../../pipes/safe-html.pipe';

@Component({
    selector: 'app-password-preview',
    templateUrl: './password-preview.component.html',
    styleUrls: ['./password-preview.component.scss'],
    standalone: true,
    imports: [BannerPreviewComponent, FormsModule, SafeHtmlPipePipe]
})
export class PasswordPreviewComponent {

  @Input() productGroup: ProductGroup;
  @Input() client: Client;

  viewProductInfo: boolean = false;

  constructor() { }
}
